export default __webpack_public_path__ + "static/media/Markers_Blue Marker.7a7daa73.svg";